import { getPaymentStatusByOrderId } from '../../helpers/pinflagRequest'
import { parseReferenceId } from '../../helpers/payment/paymentOrderParsers'
import { DataContext } from '../../context/DataContext'
import { useContext } from 'react'
import { usePurchaseOrder } from './usePurchaseOrder'
import { usePayment } from './usePayment/usePayment'

export const usePaymentOrderHandlers = () => {
  const {
    paymentState,
    setPaymentOrderResult,
    setPaymentState,
    resetCardData
  } = usePayment()

  const { userInfo, setShowFinalLoader } = useContext(DataContext)

  const { createPurchaseOrder, retryPurchaseOrder, handlePurchaseOrderSuccess } = usePurchaseOrder()

  const setPaymentOrderValues = ({ result, gateway }) => {
    setPaymentState((prevState) => ({
      ...prevState,
      hasConfirmedPaymentMethod: false,
      isPaying: false,
      paymentSuccess: true,
      paymentOrderResult: result,
      paymentSuccessfulInformation: {
        name: userInfo.names.substring(0, userInfo.names.indexOf(' ')),
        email: userInfo.email,
        referenceId: parseReferenceId({
          gateway,
          referenceId: result.referenceId
        })
      }
    }))
  }

  const handlePaymentOrderApproved = async ({
    result,
    gateway,
    paymentMethod
  }) => {
    setPaymentOrderValues({ result, gateway })
    try {
      const response = await createPurchaseOrder({ gateway, paymentMethod, referenceId: result.referenceId })
      if (response?.isUsingScraper) return
      handlePurchaseOrderSuccess(response)
    } catch (error) {
      console.error('❗Error al crear la orden de compra:', error)
      const retryResponse = await retryPurchaseOrder({ paymentGateway: gateway, paymentMethod, orderId: result.id, referenceId: result.referenceId, retries: 0 })
      if (retryResponse?.isUsingScraper) return
      if (retryResponse?.orderId) handlePurchaseOrderSuccess(retryResponse)
    }
  }

  const handlePaymentOrderRejected = ({ message }) => {
    setPaymentState((prevState) => ({
      ...prevState,
      isPaying: false,
      hasConfirmedPaymentMethod: false,
      showGatewayForm: false,
      paymentSuccess: false,
      paymentError: message || 'El pago fue rechazado, intenta nuevamente',
      isSavingCard: false,
      forceNewPayment: true
    }))
    resetCardData()
    setShowFinalLoader(false)
  }

  const pollPaymentOrderStatus = async ({
    orderId,
    force = false,
    gateway = paymentState.gateway,
    paymentMethod = paymentState.selectedPaymentOption
  }) => {
    try {
      let polling = true
      let forcePayment = force
      while (polling) {
        const response = await getPaymentStatusByOrderId({
          orderId,
          gateway,
          force: forcePayment
        })

        setPaymentOrderResult(response)

        switch (response.status) {
          case 'approved':
            polling = false
            return handlePaymentOrderApproved({
              result: response,
              gateway,
              paymentMethod
            })

          case 'rejected':
            polling = false
            return handlePaymentOrderRejected({ message: response.message })

          default:
            forcePayment = true
            await new Promise(resolve => setTimeout(resolve, 3000))
            break
        }
      }
    } catch (error) {
      console.error('❗Error al obtener el estado del pago:', error)
    }
  }

  return {
    pollPaymentOrderStatus,
    handlePaymentOrderApproved,
    handlePaymentOrderRejected
  }
}
